import Image from "next/image";

import styles from "./ImpactSection.module.scss";

const ImpactSection = () => {
  return (
    <section className={`${styles.impactSection} text-container`}>
      <p>
        Volunteer experiences have a direct and positive impact on local
        communities by injecting money into the local economy through the
        purchase of food, transportation, and tourism activities. Volunteering
        is a great way to give back to the comunity and make a difference in the
        world. Depending on the type of volunteer experience you are interested
        in, your time can be spent improving educational resources and
        opportunities, providing medical services to underserved communities, or
        promoting environmental conservation and sustainable farming techniques.
      </p>
      <div className={`${styles.impacts}`}>
        <article className={`${styles.impact}`}>
          <span className={`${styles.imageWrapper}`}>
            <Image
              src="https://res.cloudinary.com/dail4fbms/image/upload/v1719926608/One_Tree_Planted_e9b7bce35b_ary1js.png"
              alt="One Tree Planted logo"
              width={200}
              height={200}
            />
          </span>
          <div className={`${styles.text}`}>
            <p>
              25 trees will be planted on your behalf for every experience
              purchased, via our partnership with One Tree Planted.
            </p>
            <p>
              See more at
              <a
                href="https://onetreeplanted.org"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                onetreeplanted.org
              </a>
            </p>
          </div>
        </article>
        <article className={`${styles.impact}`}>
          <span className={`${styles.imageWrapper}`}>
            <Image
              src="https://res.cloudinary.com/dail4fbms/image/upload/v1663249684/1_for_the_planet_Logo_784609ab57.jpg"
              alt="1% for the Planet Logo"
              width={200}
              height={200}
            />
          </span>
          <div className={`${styles.text}`}>
            <p>
              1% of gross sales will be donated to 1% for the Planet-approved
              charities via our partnership with 1% for the Planet.
            </p>
            <p>
              See more at
              <a
                href="https://onepercentfortheplanet.org"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                onepercentfortheplanet.org
              </a>
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

export default ImpactSection;
